import { ascend, chain, concat, pathOr, pipe, prop, sort, uniq } from 'ramda';
import { createSelector } from 'reselect';
import { shallow } from 'zustand/shallow';
import { MODE } from '../../../constants';
import { useSportsbookSelector } from '../../store';

export const selectCyberSportCategories = () =>
  createSelector(
    pathOr({}, ['categories', MODE.PRE_MATCH, 'data']),
    pathOr([], ['categories', MODE.PRE_MATCH, 'ids']),
    pathOr({}, ['categories', MODE.IN_PLAY, 'data']),
    pathOr([], ['categories', MODE.IN_PLAY, 'ids']),
    (preMatchData, preMatchIds, liveData, liveIds) => {
      const filterMapCategories = (categoryId) => {
        const preMatchCategory = preMatchData[categoryId];
        const liveCategory = liveData[categoryId];

        if (!liveCategory && !preMatchCategory) {
          return [];
        }

        const mixedCategory = { ...preMatchCategory, ...liveCategory };

        return {
          ...mixedCategory,
          sportSlug: categoryId,
          sportName: mixedCategory.categoryName,
          sportId: mixedCategory.categoryId,
          eventCount:
            (liveCategory?.eventCount ?? 0) +
            (preMatchCategory?.eventCount ?? 0)
        };
      };

      return pipe(
        concat(preMatchIds),
        uniq,
        chain(filterMapCategories),
        sort(ascend(prop('categoryWeigh')))
      )(liveIds);
    }
  );

export const useCyberSportCategories = () =>
  useSportsbookSelector(selectCyberSportCategories, [], shallow);
